import React from 'react'
import { HeaderFixed, NavbarSettingOffcanvasMobileDisplay } from '../HeaderStyled'
import OffCanvasMobile from '../OffCanvasMobile'
import PrimaryHeader from '../PrimaryHeader/PrimaryHeader'

const Header: React.FC = () => {

    return (
        <>
            <HeaderFixed>

                <NavbarSettingOffcanvasMobileDisplay>
                    <OffCanvasMobile />
                </NavbarSettingOffcanvasMobileDisplay>

                <PrimaryHeader />

            </HeaderFixed>
        </>
    )
}

export default Header;